export default __webpack_public_path__ + "static/media/PipePump.256.87c6e579.png";